export function Skeleton() {
  return (
    <div className="skeletons" role="status" aria-label="Carregando dados" data-testid="loading">
      <span />
      <span />
      <span />
    </div>
  );
}
